import { FC, useEffect, useState } from "react";
import { DrawerComponent } from "src/components/DialogComponent";
import { FlexRow, FlexCol } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import { SelectIcon } from "./SelectIcon";
import TestsModule from "../components/Tests";
import TestProvider from "../components/Tests/store/TestProvider";
import { ITesting } from "../components/Tests/types";
import { PencilIcon } from "@heroicons/react/24/outline";

interface IProps {
  onResult: (data: ITesting) => void;
  zIndex: number;
}

const SelectTests: FC<IProps> = ({ zIndex, onResult }) => {
  const questionsList = localStorage.getItem("questions");

  const [openDrawer, setOpenDrawer] = useState(false);
  const [tests, setTests] = useState(questionsList?.length ? JSON.parse(questionsList).questions : []);

  useEffect(() => {
    setTests(questionsList?.length ? JSON.parse(questionsList) : []);
  }, [questionsList]);

  const isEmpty = !tests.length;

  function toggleDrawer() {
    setOpenDrawer(!openDrawer);
  }

  return (
    <FlexRow className={twMerge(isEmpty ? "" : "text-black", "flex items-center justify-between p-9 flex-nowrap font-medium")}>
      <FlexCol className="text-[18px]">Тестирование: {isEmpty ? " не требуется" : ` требуется, ${tests.length} вопросов`}</FlexCol>
      <FlexCol className="shrink-0">
        <button onClick={toggleDrawer}>
          <PencilIcon width={24} height={24} color="#9CA3AF" />
        </button>
      </FlexCol>
      <DrawerComponent percentage="87" zIndex={zIndex} open={openDrawer} toggleDrawer={toggleDrawer}>
        <TestProvider>
          <TestsModule zIndex={zIndex} closeTests={toggleDrawer} onResult={onResult} />
        </TestProvider>
      </DrawerComponent>
    </FlexRow>
  );
};

export default SelectTests;
